<template>
    <div class="form-group bs-form-group">
        <label :for="name" class="text-uppercase mb-0">{{ label }}</label>
        <div style="height:360px;">
            <mapbox @updatePoly="updatePoly" :poly="value" :draw="true" :reDraw="reDraw" @mousePosition="mousePosition" />
        </div>
        <small class="form-text text-danger" v-if="error && error[name]">{{ error[name][0] }}</small>
    </div>
</template>

<script>
export default {
  name: 'MapPolygon',
  props: ['type', 'label', 'name', 'help', 'value', 'error', 'reDraw'],
  data () {
    return {
      poly: null
    }
  },
  watch: {
    poly: function (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    mousePosition (val) {
      this.$emit('mousePosition', val)
    },
    updatePoly (val) {
      this.poly = val
    }
  }
}
</script>

<style lang="scss">
    .bs-form-group {
        > label {
            font-size: 0.75rem;
            font-weight: 600;
        }
    }
</style>
